import { render, staticRenderFns } from "./ExpandableText.vue?vue&type=template&id=299e0cef&scoped=true&"
import script from "./ExpandableText.vue?vue&type=script&lang=js&"
export * from "./ExpandableText.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableText.vue?vue&type=style&index=0&id=299e0cef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299e0cef",
  null
  
)

export default component.exports